var _style, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeasonAbstractionOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#F27E30;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#F27E30;stroke-width:2;}\n\t.st2{fill:none;stroke:#F27E30;stroke-width:2;stroke-opacity:0.8;}\n\t.st3{fill:#F27E30;stroke:#F27E30;stroke-width:0.1;stroke-opacity:0.8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,38h24H12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,38h24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.1,9h40c0.6,0,1,0.4,1,1v23c0,0.6-0.4,1-1,1h-40c-0.6,0-1-0.4-1-1V10C3.1,9.4,3.6,9,4.1,9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.6,13.1h21.3c0.4,0,0.8,0.3,0.8,0.8V26c0,0.4-0.3,0.8-0.8,0.8H11.6c-0.4,0-0.8-0.3-0.8-0.8V13.9 C10.8,13.4,11.2,13.1,11.6,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.1,29.9c0-0.4,0.3-0.8,0.8-0.8H36v-13c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8v12.5v0.4 c0,0.8-0.7,1.5-1.5,1.5H13.9C13.4,30.6,13.1,30.3,13.1,29.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeasonAbstractionOrange);
export default __webpack_public_path__ + "static/media/season_abstraction_orange.60296aff689e072eb13d057166e93cdf.svg";
export { ForwardRef as ReactComponent };